import { CheckCircle2, Circle, ChevronRight } from 'lucide-react';

const STEPS = [
  {
    id: 'connections',
    label: 'Connect Oracle',
    detail: 'Add your HCM tenant',
  },
  {
    id: 'reports',
    label: 'Load data',
    detail: 'Pull or upload reports',
  },
  {
    id: 'recon',
    label: 'Run checks',
    detail: 'Recon & pre-payroll',
  },
  {
    id: 'results',
    label: 'Review results',
    detail: 'Fix exceptions',
  },
];

const DISMISS_KEY = 'workflowGuideDismissed';

export function isWorkflowGuideDismissed() {
  return localStorage.getItem(DISMISS_KEY) === '1';
}

export function dismissWorkflowGuide() {
  localStorage.setItem(DISMISS_KEY, '1');
}

export default function WorkflowGuide({ currentView, onNavigate, hcmConfigured, dismissed, onDismiss }) {
  if (dismissed) return null;

  const stepIndex = STEPS.findIndex((s) => s.id === currentView);
  const activeIdx = stepIndex >= 0 ? stepIndex : 0;

  return (
    <div className="workflow-guide mb-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-cyan-500/90">
            Recommended workflow
          </p>
          <p className="mt-0.5 text-sm text-slate-400">
            New to the tool? Follow these four steps each pay cycle.
          </p>
        </div>
        <button type="button" onClick={onDismiss} className="text-xs text-slate-500 hover:text-slate-300">
          Dismiss
        </button>
      </div>

      <ol className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((step, idx) => {
          const done =
            (step.id === 'connections' && hcmConfigured) ||
            (idx < activeIdx && stepIndex >= 0) ||
            (step.id === 'results' && currentView === 'results');
          const active = step.id === currentView;
          const Icon = done ? CheckCircle2 : Circle;

          return (
            <li key={step.id}>
              <button
                type="button"
                onClick={() => onNavigate(step.id)}
                className={`workflow-step ${active ? 'workflow-step-active' : ''}`}
              >
                <span className="flex items-center gap-2">
                  <Icon
                    className={`h-4 w-4 shrink-0 ${
                      done ? 'text-emerald-400' : active ? 'text-cyan-400' : 'text-slate-500'
                    }`}
                  />
                  <span className="text-left">
                    <span className="block text-sm font-medium text-slate-100">{step.label}</span>
                    <span className="block text-xs text-slate-500">{step.detail}</span>
                  </span>
                </span>
                <ChevronRight className="h-4 w-4 shrink-0 text-slate-600" />
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
